module.exports = __webpack_public_path__ + "img/accounts.weekly.a1235e0f.png";